var _style, _defs, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3Ascending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_2_);fill:#1C3C6B;}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 20,
    height: 20
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.1,1.5l-1.2,2.7c-0.1,0.2-0.3,0.3-0.5,0.2c-0.1,0-0.2-0.1-0.2-0.2l-0.4-0.9L2.1,10.5 c-0.4,0.2-0.9,0-1.1-0.4L0.9,9.9c-0.2-0.4,0-0.9,0.4-1.1L16,1.7l-0.4-0.9c-0.1-0.2,0-0.4,0.2-0.5c0.1,0,0.2-0.1,0.3,0l2.9,0.7 C19.1,1,19.2,1.2,19.1,1.5C19.2,1.4,19.1,1.4,19.1,1.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.5,10.4h1.1c0.4,0,0.7,0.3,0.7,0.7V19c0,0.4-0.3,0.7-0.7,0.7H9.5c-0.4,0-0.7-0.3-0.7-0.7v-7.9 C8.7,10.7,9.1,10.4,9.5,10.4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.5,7.1h1.1c0.4,0,0.7,0.3,0.7,0.7V19c0,0.4-0.3,0.7-0.7,0.7h-1.1c-0.4,0-0.7-0.3-0.7-0.7V7.8 C15.7,7.4,16,7.1,16.5,7.1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2.7,12.6h1.1c0.4,0,0.7,0.3,0.7,0.7V19c0,0.4-0.3,0.7-0.7,0.7H2.7C2.3,19.7,2,19.4,2,19v-5.7 C2,12.9,2.3,12.6,2.7,12.6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3Ascending);
export default __webpack_public_path__ + "static/media/3_Ascending.fddb2a3b757ef43d738d56b772a27219.svg";
export { ForwardRef as ReactComponent };